<app-pt-navbar></app-pt-navbar>
<div class="portal-page"><router-outlet /></div>
<!-- <app-pt-footer></app-pt-footer> -->
